<template>
  <v-container fluid class="currency-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Currency</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">New Currency</p>
                        <v-text-field
                          class="mb-4"
                          v-model="currency.currencycode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Currency Code"
                          persistent-hint
                          single-line hint="Enter the currency code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="currency.currencyname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Currency Name"
                          persistent-hint
                          single-line hint="Enter the currency name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="currency.currencytype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the currency type">
                        </v-select>
                          <v-switch
                            v-model="currency.currencystatus"
                            color="primary"
                            v-bind:label="currency.currencystatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/currency/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertCurrency()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      currency: {currencystatus: 'Active'},
      items: ['Currency', 'Other Currency'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Currency', ['insertCurrencyRequest', 'getCurrenciesRequest']),
    checkError(){
      if(!this.currency.currencycode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.currency.currencyname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.currency.currencytype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async insertCurrency() {
      if(!this.checkError()) return;
      await this.insertCurrencyRequest(this.currency);
      this.getCurrenciesRequest();
      router.push('/currency/list');
    },
  },
  computed: {
    ...mapState('Currency', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
